(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/sok-widget/assets/javascripts/sok-widget.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/sok-widget/assets/javascripts/sok-widget.js');
"use strict";


const cdn = svs.core.config.data.svsconfig.cdn;
class SokWidget extends HTMLElement {
  connectedCallback() {
    const shadowRoot = this.attachShadow({
      mode: 'open'
    });
    const css = "\n      .logo-container img {\n        width: 50px;\n        margin: 0 0 12px 0;\n      }\n    ";
    shadowRoot.innerHTML = "\n      <style>".concat(css, "</style>\n      <div class=\"logo-container\">\n        <img src=\"").concat(cdn, "/images/oddset-kambi/components/sok-widget/SOK_SvS_Flagga_RGB.png\" alt=\"SOK Logo\">\n      </div>\n   ");
  }
}
customElements.define('sok-widget', SokWidget);

 })(window);